var map = {
	"./bs_t-1_stitch_blk.png": 254918,
	"./bs_t-1_stitch_blu.png": 182984,
	"./bs_t-1_stitch_cml.png": 290731,
	"./bs_t-1_stitch_crk.png": 741761,
	"./bs_t-1_stitch_grn.png": 88312,
	"./bs_t-1_stitch_lgd.png": 212254,
	"./bs_t-1_stitch_lsl.png": 63978,
	"./bs_t-1_stitch_nvy.png": 7958,
	"./bs_t-1_stitch_orn.png": 874320,
	"./bs_t-1_stitch_pnk.png": 643658,
	"./bs_t-1_stitch_ppl.png": 814983,
	"./bs_t-1_stitch_red.png": 399286,
	"./bs_t-1_stitch_sax.png": 998107,
	"./bs_t-1_stitch_wht.png": 817696,
	"./bs_t-1_stitch_ylw.png": 337033
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 437756;